export default "__VITE_ASSET__BEWC5vB7__"